import * as z from "zod";
import { mutator } from "./mutator";

export const deleteWorkflowRunVolumeDataSchema = z.object({
  workflowId: z.string(),
  volumeId: z.string(),
  category: z.enum(["run_volume", "step_test_volume"]),
  // Narrows step-test copies to one branch’s.
  branchId: z.string().optional(),
});

export const deleteWorkflowRunVolumeData = mutator({
  schema: deleteWorkflowRunVolumeDataSchema,
  resolve: {
    workflow: { kind: "workflow", from: "workflowId" },
  },
  permissions: [
    {
      permission: "space:write",
      scopeId: ({ args }) => args.workflow.spaceId,
    },
  ],
  description:
    "Deletes a volume’s data kept from a workflow’s runs or step tests.",
  interactionType: "delete",
  fn: async () => {},
});
